import React, { useMemo } from 'react';
import { WithLoadingComponent, SVGLoader, DownloadOptionTemplate, PaginatorContainer } from 'components';
import { ReportingService } from 'services/http';
import Utils, { REPORTING_ENDPOINTS_SUFFIXES } from "utils";
import { AgentLoggedIn } from 'components/pages/analytics-page/activity/agent-logged';

export const AgentActivity = (props) => {

    const { data } = props;
    const cols = data.length ? Object.keys(data[0].dataValue[0]).filter(col => col !== "date") : [];

    data.map(item => {
        item.dataValue.map(obj => {
            delete obj["date"];
            obj["loggonTime"] = Utils.msToDHMSBis(obj["loggonTime"] * 1000);
            obj["activeTime"] = Utils.msToDHMSBis(obj["activeTime"] * 1000);
            obj["inactiveTime"] = Utils.msToDHMSBis(obj["inactiveTime"] * 1000);
            obj["pauseTime"] = Utils.msToDHMSBis(obj["pauseTime"] * 1000);
            obj["agent"] = obj["agent"].toUpperCase();
            return obj;
        })
        return item;
    })

    return (
        <>
            <div className='mx-4 mb-4'>
                <AgentLoggedIn />
            </div>
            {
                data.length ?
                    <PaginatorContainer className="my-4" defaultRows={5}>
                        {data.reverse().map((item) => {
                            return <div className="mx-4" >
                                <DataTable title={`Activity detail of ${item.dataName}`} columns={cols} rows={item.dataValue.map((item) => Object.values(item))} />
                            </div>
                        })}
                    </PaginatorContainer>
                    : Utils.NoItemsTemplate()
            }
        </>
    );
}

export const AgentActivityHoc = (props) => {
    const filterSearchParam = JSON.parse(new URLSearchParams(window.location.search).get("filter"));
    const AgentsActHoc = useMemo(() => WithLoadingComponent(AgentActivity, () => ReportingService.getAgentActivity(Utils.buildFilterCriteria(filterSearchParam)), <SVGLoader label="Loading..." />)(props), []);
    return <>
        <AgentsActHoc />
        <div className="m-3">
            <DownloadOptionTemplate downloadReport={(type) => ReportingService.downloadKpiReport(REPORTING_ENDPOINTS_SUFFIXES.ACTIVITY_AGENT, Utils.buildFilterCriteria(filterSearchParam), type)} />
        </div>
    </>
}

export const DataTable = (props) => {
    const { title, columns, rows } = props;
    return <table>
        <thead>
            <tr>
                <th className="h-title" colspan="1"><pre className="m-0">{title}</pre></th>
            </tr>
            <tr>
                {columns.map(column => <th className="h-column">{column}</th>)}
            </tr>
        </thead>
        <tbody>
            {rows.map(items => <tr>{items ? items.map(item => <td>{item}</td>) : null}</tr>)}
        </tbody>
    </table>
}